import log from 'loglevel';

log.setLevel("debug")

export default log;